import * as types from '../actions/actionTypes';
import initialState from './initialState';

function actionTypeEndsInSuccess(type){
    return type.substring(type.length - 8) === '_SUCCESS';
}

/**
 * reducer per gestire le ajaxCallsInProgress
 * @param {*} state
 * @param {*} action
 */
export default function ajaxStatusReducer(state = initialState.ajaxCallsInProgress, action){
    if(action.type === types.BEGIN_AJAX_CALL){
        return state + 1;
    }
    else if(action.type === types.AJAX_CALL_ERROR){
        return state - 1;
    }
    else if(actionTypeEndsInSuccess(action.type)){
        /*
            ogni volta che viene eseguito un dispatch redux esegue questo reducer.
            eseguirà un decremento perchè è stato aggiunto un dispatch(loadcursessuccess) nel then della promise
            presente in courseActions

            decrementa solo se la chiamata ha come sito SUCCESS actionTypeEndsInSuccess()
        */

        return state - 1;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/ajaxStatusReducer.js